module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921013834_T.47dc059c.jpg";